import { render, staticRenderFns } from "./EmailAttachments.vue?vue&type=template&id=30e636cb&scoped=true&"
import script from "./EmailAttachments.vue?vue&type=script&lang=ts&"
export * from "./EmailAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./EmailAttachments.vue?vue&type=style&index=0&id=30e636cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e636cb",
  null
  
)

export default component.exports